import User01 from "../../Svg/User01";
import constants from "../../constants";
import Logout02 from "../../Svg/Logout02";
import Avatar from "@mui/material/Avatar";
import Popover from "@mui/material/Popover";
import { useContext, useState } from "react";
import useLogout from "../../Hooks/useLogout";
import { useLocation } from "react-router-dom";
import { getDataFromStorage } from "../../util";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import AlertContext from "../../context/AlertContext";
import useS3FileManagement from "../../Hooks/useS3FileManagement";
import { useEffect } from "react";
export default function ProfileAvatar() {
  const Alert = useContext(AlertContext);
  const { getPreSignedUrl } = useS3FileManagement();
  const logout = useLogout();

  const location = useLocation();

  const [anchorEl, setAnchorEl] = useState(null);
  const [profilePictureUrl, setProfilePictureUrl] = useState("");
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  useEffect(() => {
    const getProfilePictureUrl = async () => {
      try {
        const pictureKey =
          Alert.userProfilePic || localStorage.getItem("picture");

        console.log("Profile picture key:", pictureKey);

        if (!pictureKey) {
          setProfilePictureUrl("");
          return;
        }

        const res = await getPreSignedUrl([pictureKey], undefined, "", "GET");

        console.log("Presigned profile picture URL:", res);

        setProfilePictureUrl(res?.url?.[0] || "");
      } catch (error) {
        console.error("Error generating profile picture URL:", error);

        setProfilePictureUrl("");
      }
    };

    getProfilePictureUrl();
  }, [Alert.userProfilePic]);

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const handleLogOut = async () => {
    localStorage.removeItem("tokenKey");

    Alert.setLoginStatus(false);

    await logout();

    Alert.navigate("/", { state: { from: location }, replace: true });

    window.location.reload();
  };
  console.log("profile avatar pic :", Alert.userProfilePic);

  return (
    <div className="headerAvatarContainer">
      <IconButton className="headerAvatarIcon" onClick={handleClick}>
        <Avatar
          alt={getDataFromStorage("name")}
          style={{ width: "32px", height: "32px", padding: 0 }}
          src={profilePictureUrl || localStorage.getItem("picture")}
        />
      </IconButton>
      <Popover
        open={open}
        anchorEl={anchorEl}
        id="headerAvatarPopover"
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <div className="headerAvatarUserNameContainer">
          <div className="headerAvatarUserNameSec headerAvatarDetailSec">
            <Avatar
              alt={getDataFromStorage("name")}
              src={profilePictureUrl || localStorage.getItem("picture")}
            />
            <Typography className="headerAvatarUserName">
              {getDataFromStorage("name")}
            </Typography>
          </div>
        </div>
        {getDataFromStorage("role") !== constants.Roles.hr &&
          getDataFromStorage("role") !== constants.Roles.tutor &&
          getDataFromStorage("role") !== constants.Roles.customer &&
          getDataFromStorage("role") !== constants.Roles.parent &&
          getDataFromStorage("role") !== constants.Roles.evaluator &&
          getDataFromStorage("role") !== constants.Roles.super_admin &&
          parseInt(localStorage.getItem("batchType")) !==
            constants.BATCH_TYPE.TESTING && (
            <div
              className="headerAvatarViewProfileContainer"
              onClick={() => {
                Alert.navigate("/profile/personalinfo");
                setAnchorEl(null);
              }}
            >
              <div className="headerAvatarViewProfileSec headerAvatarDetailSec">
                <User01
                  width="20"
                  height="20"
                  stroke="#344054"
                  strokeWidth="1.6"
                />
                <Typography className="headerAvatarViewProfile">
                  View Profile
                </Typography>
              </div>
            </div>
          )}
        {/* {Alert.isAdmin && getDataFromStorage("role") !== constants.Roles.evaluator && location.pathname !== "/company" && (
          <div
            className="headerAvatarCompanyProfileContainer"
            onClick={() => {
              Alert.navigate("/profile/companyinfo");
              setAnchorEl(null);
            }}
          >
            <div className="headerAvatarCompanyProfileSec headerAvatarDetailSec">
              <svg
                width="20"
                height="20"
                fill="none"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke="#344054"
                  strokeWidth="1.6"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M22 21V19C22 17.1362 20.7252 15.5701 19 15.126M15.5 3.29076C16.9659 3.88415 18 5.32131 18 7C18 8.67869 16.9659 10.1159 15.5 10.7092M17 21C17 19.1362 17 18.2044 16.6955 17.4693C16.2895 16.4892 15.5108 15.7105 14.5307 15.3045C13.7956 15 12.8638 15 11 15H8C6.13623 15 5.20435 15 4.46927 15.3045C3.48915 15.7105 2.71046 16.4892 2.30448 17.4693C2 18.2044 2 19.1362 2 21M13.5 7C13.5 9.20914 11.7091 11 9.5 11C7.29086 11 5.5 9.20914 5.5 7C5.5 4.79086 7.29086 3 9.5 3C11.7091 3 13.5 4.79086 13.5 7Z"
                />
              </svg>

              <Typography className="headerAvatarCompanyProfile">
                Company Profile
              </Typography>
            </div>
          </div>
        )} */}
        <div className="headerAvatarLogoutContainer" onClick={handleLogOut}>
          <div className="headerAvatarLogoutSec headerAvatarDetailSec">
            <Logout02
              width="20"
              height="20"
              stroke="#344054"
              strokeWidth="1.6"
            />
            <Typography className="headerAvatarLogout">Log Out</Typography>
          </div>
        </div>
        {Alert.isAdmin && (
          <div className="versionum">
            {" "}
            <Typography>{process.env.REACT_APP_VERSION}</Typography>
          </div>
        )}
      </Popover>
    </div>
  );
}
